const typography = {
  h1: {
    font: 'normal normal bold 57px/72px Roboto Condensed',
    letterSpacing: '0px',
  },
  h5: {
    font: 'normal normal bold 27px/34px Roboto Condensed',
    letterSpacing: '0px',
  },
  h6: {
    font: 'normal normal normal 18px/23px CircularStd;',
    letterSpacing: '0px',
  },
  h7: {
    font: 'normal normal normal 18px/46px CircularStd;',
    letterSpacing: '0px',
  },
  veryBoldHeading: {
    font: 'normal normal 900 30px/38px CircularStd;',
  },
  boldHeading: {
    font: 'normal normal bold 22px/55px Roboto Condensed',
  },
  navlink: {
    font: 'normal normal normal 18px/40px CircularStd',
    letterSpacing: '0px',
  },
  newLink: {
    font: 'normal normal normal 14px/45px CircularStd',
    letterSpacing: '0px',
  },
  p: {
    font: 'normal normal normal 15px/19px  Roboto Condensed',
    letterSpacing: '0px',
  },
  pDescription: {
    font: 'normal normal normal 16px/19px CircularStd',
    letterSpacing: '0px',
  },
  label: {
    font: 'normal normal normal 14px/19px CircularStd',
    letterSpacing: '0px',
  },

  buttons: {
    standard: {
      font: 'normal normal normal 14px/45px CircularStd',
      fontWeight: 400,
    },
    'standard-bold': {
      font: 'normal normal bold 14px/45px CircularStd',
    },
    popoverOption: {
      font: ' normal normal normal 14px/17px CircularStd',
    },
  },

  filterItem: {
    font: 'normal normal normal 15px/19px  Lato , sans-serif',
    fontWeight: 500,
    letterSpacing: '0px',
    color: 'write'
  },
};

export default typography;
